import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const manageProjectsDirectoryRoute: InvariantJiraRoute = {
	name: 'projects-directory-manage',
	path: '/jira/settings/projects/manage',
};
